import React from 'react';
import SelectSetting from '../../common/SelectSetting.jsx';
import FormulaFieldActions from '../formula/FormulaFieldActions.jsx';

// `allowFormula` shows "Create formula" / "Edit formula" actions below the picker
function ColumnSelectSetting ({ allowFormula = false, ...props }) {
  return (
    <SelectSetting {...props} options={props.columnDefs}>
      {allowFormula && <FormulaFieldActions {...props} />}
    </SelectSetting>
  )
}

export default ColumnSelectSetting;
